<template>
  <v-dialog scrollable width="90vw" :value="value">
    <v-card color="kbLightGray">
      <v-card-text>
        <v-row no-gutters>
          <v-col cols="12">
            <span class="d-block kbDarkBlue--text py-5"
                  style="font-size: 20px">
              {{ $t('general.peopleFilters') }}
            </span>
          </v-col>
          <v-col cols="12">
            <PeopleFilters @openPeopleFilters="openPeopleFilters()" />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import PeopleFilters from '@/pages/App/People/Filters/PeopleFilters'
export default {
  components: { PeopleFilters },
  methods: {
    openPeopleFilters () {
      if (this.$vuetify.breakPoint.smAndDown) {
        this.$emit('openPeopleFilters')
      }
    },
    toggleModal () {
      this.$emit('input', false)
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
  ::v-deep div.v-menu__content div.filter-other-data-item-checkbox input {
    display: none;
  }
</style>
